export const ANALYTICS_EVENTS = Object.freeze({
  // Screen
  SCREEN_VIEW: 'screen_view',

  // Auth
  LOGIN: 'login',
  SIGN_UP: 'sign_up',
  LOGOUT: 'logout',
  OTP_SENT: 'otp_sent',
  OTP_VERIFIED: 'otp_verified',
  OTP_RESEND: 'otp_resend',
  OTP_FAILED: 'otp_failed',

  // CTA / UI
  CTA_CLICK: 'cta_click',

  // Form lifecycle
  FORM_START: 'form_start',
  FORM_SUBMIT: 'form_submit',
  FORM_COMPLETE: 'form_complete',
  FORM_VALIDATION_ERROR: 'form_validation_error',
  FORM_SUBMIT_ERROR: 'form_submit_error',

  // Journey funnel
  JOURNEY_START: 'journey_start',
  JOURNEY_STEP: 'journey_step',
  JOURNEY_COMPLETE: 'journey_complete',
  JOURNEY_FAILURE: 'journey_failure',

  // Investment
  INVEST_START: 'invest_start',
  INVEST_CONFIRMED: 'invest_confirmed',
  INVEST_SUCCESS: 'invest_success',
  INVEST_FAILED: 'invest_failed',
  SIP_CREATED: 'sip_created',
  SWP_CREATED: 'swp_created',
  STP_CREATED: 'stp_created',
  SWITCH_INITIATED: 'switch_initiated',
  SWITCH_COMPLETE: 'switch_complete',

  // Redemption
  REDEEM_START: 'redeem_start',
  REDEEM_CONFIRMED: 'redeem_confirmed',
  REDEEM_SUCCESS: 'redeem_success',

  // Mandate
  MANDATE_CREATED: 'mandate_created',

  // Onboarding / KYC
  KYC_STARTED: 'kyc_started',
  KYC_COMPLETED: 'kyc_completed',
  KYC_FAILED: 'kyc_failed',
  BANK_ACCOUNT_LINKED: 'bank_account_linked',
  NOMINEE_ADDED: 'nominee_added',
  RISK_ASSESSMENT_COMPLETED: 'risk_assessment_completed',
  FATCA_SUBMITTED: 'fatca_submitted',

  // Portfolio / Net worth
  PORTFOLIO_VIEWED: 'portfolio_viewed',
  NET_WORTH_VIEWED: 'net_worth_viewed',

  // Consent
  CONSENT_GIVEN: 'consent_given',

  // Errors
  API_FAILURE: 'api_failure',
  APP_ERROR: 'app_error',

  // Notifications
  NOTIFICATION_VIEWED: 'notification_viewed',
});

export const ANALYTICS_JOURNEYS = Object.freeze({
  LOGIN: 'login',
  REGISTRATION: 'registration',
  OTP_VERIFICATION: 'otp_verification',
  KYC: 'kyc',
  BANK_LINKING: 'bank_linking',
  NOMINEE: 'nominee',
  RISK_ASSESSMENT: 'risk_assessment',
  INVESTMENT: 'investment',
  SIP_SETUP: 'sip_setup',
  SWP_SETUP: 'swp_setup',
  STP_SETUP: 'stp_setup',
  SWITCH: 'switch',
  REDEMPTION: 'redemption',
  MANDATE_SETUP: 'mandate_setup',
  NET_WORTH_CONSENT: 'net_worth_consent',
});

export const ANALYTICS_FORMS = Object.freeze({
  LOGIN: 'login',
  SIGNUP: 'signup',
  OTP: 'otp',
  KYC: 'kyc',
  BANK_ACCOUNT: 'bank_account',
  NOMINEE: 'nominee',
  INVEST: 'invest',
  REDEEM: 'redeem',
  SWP: 'swp',
  STP: 'stp',
  SWITCH: 'switch',
  RISK_ASSESSMENT: 'risk_assessment',
  FATCA: 'fatca',
  MANDATE: 'mandate',
});

export const ANALYTICS_USER_PROPERTIES = Object.freeze({
  KYC_STATUS: 'kyc_status',
  RA_STATUS: 'ra_status',
  HAS_INVESTMENTS: 'has_investments',
  CUSTOMER_TYPE: 'customer_type',
});
